import { Component } from '@angular/core';

@Component({
    selector: 'fic-screen-header-prefix,fic-screen-header-suffix',
    template: '<ng-content></ng-content>',
    standalone: false,
})
export class FicScreenHeaderTranscludeComponent {}
